import { render, staticRenderFns } from "./ProjectManagementTypeDropdown.vue?vue&type=template&id=16122a5a&"
import script from "./ProjectManagementTypeDropdown.vue?vue&type=script&lang=ts&"
export * from "./ProjectManagementTypeDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports